import { createSlice } from '@reduxjs/toolkit'
import { notificationType } from 'pages/notificationReporting/constants'

const initialState = {
  processing: false,
  success: '',
  loading: false,
  page: 0,
  data:[],
  error: '',
  hasNext: false,
  hasPrev: false,
  totalPage:0,
  selectedTab: notificationType[0],
}

const notificationReportSlice = createSlice({
  name: 'notificationReportSlice',
  initialState: initialState,
  reducers: {
    tryFetchNotificationReport: () => {},
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true
      state.success = ''
    },
    setSuccess: (state, action) => {
      state.success = action.payload
      state.processing = false
    },
    setNotificationLoading: (state) => {
      state.loading = true
      state.error = ''
    },
    setNotificationReport: (state, action) => {
      const { error, page, data, hasNext , hasPrev, totalPage} = action.payload
      if (error) {
        state.error = error
      } else {
        state.data = data;
        state.page = page ?? state.scheduled.page;
        state.hasNext = hasNext ?? state.scheduled.hasNext;
        state.hasPrev = hasPrev ?? state.scheduled.hasPrev;
        state.totalPage = totalPage ?? state.scheduled.totalPage;
      }
      state.loading = false
    },
    setActiveTab: (state, action) => {
      state.selectedTab = action.payload;
    }
  },
})

export const {
  setProcessing,
  setSuccess,
  setNotificationReport,
  setNotificationLoading,
  setActiveTab,
  tryFetchNotificationReport
} = notificationReportSlice.actions
export default notificationReportSlice.reducer
